export default function () {
    return /\kwaiying\//.test(navigator.userAgent) || !!window.kwaiying;
}
